import { render, staticRenderFns } from "./DynameatSpinner.vue?vue&type=template&id=38e49c4b&scoped=true&"
import script from "./DynameatSpinner.vue?vue&type=script&lang=js&"
export * from "./DynameatSpinner.vue?vue&type=script&lang=js&"
import style0 from "./DynameatSpinner.vue?vue&type=style&index=0&id=38e49c4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e49c4b",
  null
  
)

export default component.exports